import { default as parentScope } from '../types';
const SCOPE = `${parentScope}.schedule`;
export default SCOPE;

export const INIT = `${SCOPE}/INIT`;
export const SET_TAB = `${SCOPE}/SET_TAB`;
export const SET_SORT_BY = `${SCOPE}/SET_SORT_BY`;

// form section
export const FORM_SCOPE = `${SCOPE}.form`;
export const FORM_TYPES = {
  INIT: `${FORM_SCOPE}/INIT`,
  SET_POLICIES: `${FORM_SCOPE}/SET_POLICIES`,
  SET_ORDER: `${FORM_SCOPE}/SET_ORDER`,
  SET_ACTIVATION_STATE: `${FORM_SCOPE}/SET_ACTIVATION_STATE`,
  SET_TRIGGER_AT: `${FORM_SCOPE}/SET_TRIGGER_AT`,
  SET_NOTES: `${FORM_SCOPE}/SET_NOTES`,
  SET_EMAILS: `${FORM_SCOPE}/SET_EMAILS`,
  RESET: `${FORM_SCOPE}/RESET`,
  SAVE_SCHEDULE: `${FORM_SCOPE}/SAVE_SCHEDULE`,
  DELETE_SCHEDULE: `${FORM_SCOPE}/DELETE_SCHEDULE`,
  SET_LOADING: `${FORM_SCOPE}/SET_LOADING`,
  SET_VISIBLE: `${FORM_SCOPE}/SET_VISIBLE`,
  SET_FORM: `${FORM_SCOPE}/SET_FORM`,
  SET_MODAL_TYPE: `${FORM_SCOPE}/SET_MODAL_TYPE`,
};

// list section
export const LIST_SCOPE = `${SCOPE}.list`;
export const LIST_TYPES = {
  FETCH_DATA: `${LIST_SCOPE}/FETCH_DATA`,
};
